<div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-5">

  <!-- Travel Plan Cards -->
  @if (cardFor == 'travelPlan') {
    @for (data of ownerList; track $index) {
      <app-card-list
        [data]="data"
        [showActions]="showActions"
        (edit)="onActionClick.emit({ type: 'edit', data: data })"
        (delete)="onActionClick.emit({ type: 'remove', data: data })"
      ></app-card-list>
    }
  }

  <!-- Signatories Cards -->
  @else {
    @for (data of ownerList; track $index) {
      <div>
        <app-signatories-list
          [owner]="data"
          [showAction]="showActions"
          [memberLabelOwnerPartnerList]="memberLabelOwnerPartnerList"
          (onActionClick)="onActionClick.emit($event)"
        ></app-signatories-list>
      </div>
    }
  }

</div>


<!-- Carousal card -->
<!-- <div class="relative hidden">
  <div class="overflow-hidden">
    <div
      class="flex transition-transform duration-300 ease-out w-full"
      [style.transform]="'translateX(' + -currentPage * 100 + '%)'"
    >
      @for (pageItems of pages; track $index; let pi = $index) {
      <div
        class="w-full shrink-0"
        role="group"
        [attr.aria-roledescription]="'slide'"
        [attr.aria-label]="'Slide ' + (pi + 1) + ' of ' + pages.length"
      >
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-5">
          @if(cardFor == 'travelPlan'){ @for (data of pageItems; track $index) {
          <app-card-list
            [data]="data"
            [showActions]="showActions"
            (edit)="onActionClick.emit({ type: 'edit', data: data })"
            (delete)="onActionClick.emit({ type: 'remove', data: data })"
          ></app-card-list>
          } }@else { @for (data of pageItems; track $index) {
          <div>
            <app-signatories-list
              [owner]="data"
              [showAction]="showActions"
              (onActionClick)="onActionClick.emit($event)"
            />
          </div>
          } }
        </div>
      </div>
      }
    </div>
  </div>

  @if (ownerList.length > 3 || (getPerView() == 1 && ownerList.length > 1)) {
  <div class="mt-2 flex items-center justify-center gap-2">
    <button
      type="button"
      (click)="prev()"
      [disabled]="currentPage === 0"
      class="py-1 text-dc-navy font-semibold disabled:opacity-50"
    >
      <i class="fas fa-angle-left transition-transform rtl:rotate-180"></i>
      {{ "PAGENATION.PRE" | translate }}
    </button>
    @for (_ of pages; let i = $index; track $index) {
    <button
      type="button"
      class="h-2.5 w-2.5 rounded-full transition"
      [ngClass]="
        i === currentPage ? 'bg-dc-navy' : 'bg-gray-300 hover:bg-gray-400'
      "
      (click)="goTo(i)"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
    ></button>
    }
    <button
      type="button"
      (click)="next()"
      [disabled]="currentPage >= pages.length - 1"
      class="py-1 text-dc-navy disabled:opacity-50 font-semibold"
    >
      {{ "PAGENATION.NEXT" | translate }}
      <i
        class="fas fa-angle-right transition-transform rtl:rotate-180"
      ></i>
    </button>
  </div>
  }
</div> -->
